export const errorMessageMapper = {
    "Expected number, received null": "Please select a value",
    "Expected string, received null": "Please select a value",
};
